import { IPopupErrorModel, ErrorTypes } from '../state-helpers/popup-error';

export class GlobalActionType {
    static SET_ERROR_TYPE: string = "SET_ERROR_TYPE";
    static SET_CUSTOM_ERROR_TEXT: string = "SET_CUSTOM_ERROR_TEXT";
    static SET_PAGE: string = "SET_PAGE";
    static TOGGLE_FILTER: string = "TOGGLE_FILTER";
}

export class ActionType extends GlobalActionType { }

export interface IAction {
    type: string;
}

export interface IPopupErrorAction extends IAction {
    errorType: ErrorTypes;
    customErrorText: string;
}

export interface ISetPageAction extends IAction {
    page: number;
}

export interface IToggleFilterAction extends IAction {
    filterId: string;
}

export function setPopupErrorType(newErrorType: ErrorTypes): IPopupErrorAction {
    return {
        type: ActionType.SET_ERROR_TYPE,
        errorType: newErrorType,
        customErrorText: ''
    }
}

export function setPopupErrorText(newCustomErrorText: string): IPopupErrorAction {
    return {
        type: ActionType.SET_CUSTOM_ERROR_TEXT,
        errorType: ErrorTypes.NONE,
        customErrorText: newCustomErrorText
    }
}

export function setPage(page: number): ISetPageAction {
    return {
        type: ActionType.SET_PAGE,
        page
    };
}

export function toggleFilter(filterId: string): IToggleFilterAction {
    return {
        type: ActionType.TOGGLE_FILTER,
        filterId
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/global/actions/index.ts